/**
 * jk-around.js — раздел «Что вокруг дома» на карточке ЖК (ТОЛЬКО телефон).
 *
 * Что делает: на узких экранах (<=900 px) собирает ОДИН раздел «Что вокруг дома»
 * вместо четырёх разрозненных блоков, по образцу компьютерной версии.
 * От 901 px раздел спрятан стилями, а прод-блоки возвращаются на место.
 *
 * Забирает:
 *   #jkNeighborhood    «Соседство и район»            — прячем
 *   #jkNearbyMetros    «Транспорт рядом»              — прячем
 *   #jkInfraList       список «что рядом» под картой  — прячем
 *   #jkInfraQuick      плитки-числа                   — прячем
 *   .hero-around       «Что вокруг дома» от jk-card.js — прячем (см. HIDE ниже)
 *   #jkInfraCategories «Инфраструктура вокруг ЖК»     — разбираем на плитки
 *   .jk-walkability    «60 / 100» — на телефоне скрыт, показываем внутри раздела
 *
 * ⛔ КАТЕГОРИИ БЕРЁМ ИЗ РАЗМЕТКИ, А НЕ ИЗ СВОЕГО СПИСКА. Раньше здесь лежал
 *    жёсткий перечень из четырёх категорий, и пятая — «Отдых и природа»
 *    (parkи, водоёмы, лес, спорт) — молча пропадала с телефона: в список её не
 *    внесли, а исходный блок гасили целиком. По замеру она есть у 156 ЖК из 156,
 *    в среднем 25 объектов. Теперь обходим то, что реально прислал сервер, а
 *    свой словарь задаёт лишь ПОРЯДОК и короткие подписи; незнакомая категория
 *    получает подпись и значок сервера и встаёт в конец.
 *
 * ⛔ ЧИСЛО НА ПЛИТКЕ — ПОЛНОЕ, ИЗ ПОДПИСИ СЕРВЕРА. Список в разметке обрезан
 *    PoisHandler::CATEGORY_POI_LIMIT (24 строки), поэтому `rows.length` — это
 *    «сколько показано», а НЕ «сколько есть»: «65 объектов» превращались в «24».
 *    Полное число стоит в `.jk-infra-cat__meta`, показанное — в атрибуте
 *    `data-shown` (jk_content.php). Показываем полное, а под срезанным списком
 *    честно пишем, сколько строк видно.
 *
 * ⛔ Категории делим ПО ЗНАЧКУ объекта (fa-school / fa-child-reaching /
 *    fa-graduation-cap), а не по словам в названии. Значок ставит сервер, он
 *    надёжен; «Гимназия», «Лицей», «Колледж» разбор по названию бы не поймал.
 *    Тот же признак использует код компа — CARD_SPLIT_RULES в jk-card.js.
 *    Делим ТОЛЬКО когда список полон и КАЖДАЯ строка узнана по значку: иначе
 *    доли неизвестны (в 24 показанных из 65 не видно, сколько всего школ), а
 *    неузнанная строка выпала бы из всех плиток. Не делим — плитка одна, общая.
 *
 * ⛔ Строки списка СОБИРАЮТСЯ из чужих узлов, а не клонируются — см. комментарий
 *    у сборки .zd-cat__item ниже. Клон терял оформление.
 */
(() => {
  'use strict';

  const MQ = window.matchMedia ? window.matchMedia('(max-width: 900px)') : null;
  if (!MQ) return;

  const src = document.getElementById('jkInfraCategories');
  if (!src) return;
  if (document.querySelector('.zd-around')) return;

  /* ⛔⛔ СНИМОК ИСТОЧНИКА СНИМАЕМ СЕЙЧАС, А СТРОИМ ПОЗЖЕ — ИНАЧЕ ЧИТАЕМ ЧУЖУЮ
     ПЕРЕКРОЙКУ. Сквозная проверка 21.08 нашла молчаливую поломку:

       открыть карточку В АЛЬБОМЕ 928×405 → повернуть в портрет 405×928
       было: 10 плиток, «Транспорт 4 объекта», «Медицина 3», «Отдых 4»
       правда сервера: Транспорт 10, Медицина 6, Отдых 7
       (ошибок в консоли ноль — числа просто врут)

     Раздел строится по первому УЗКОМУ экрану. Если экран был широким,
     к этому моменту js/jk-card.js успевает разобрать `#jkInfraCategories` и
     СОБРАТЬ ЕГО ЗАНОВО: пять категорий сервера превращаются в десять
     производных (`transport` → `transport` + `transport-road`, `education` →
     `education` + `kindergarten` + `university`, `medical` → `medical` +
     `hospital`, `leisure` → `leisure` + `nature`), и у каждой свой кусок
     счётчика. Замер ленты: на 434 мс в узле ещё пять категорий сервера и ноль
     `.mg-tabs`, позже — десять и три вкладки.

     ⛔ ЗАЩИТЫ «НЕ СТРОИТЬ ПРИ ЖИВЫХ .mg-tabs» (как в js/jk-blocks.js) ЗДЕСЬ
     МАЛО, и это замер, а не мнение: тогда в портрете остаётся раздел, который
     построил jk-card, а в нём те же десять производных плиток — и одна вовсе
     без названия. Числа сходятся в сумме, но человек читает подписи, а не
     сумму. У jk-blocks случай другой: там вкладки показывают ТО ЖЕ
     содержимое, и отдать их человеку — честный размен.

     Клон отсоединён от документа и никем больше не читается, поэтому чужая
     перекройка его не достаёт. Все разборщики выше (`txt`, `hasIcon`,
     `fullCount`, `shownCount`, `boxIcon`) читают текст, классы и атрибуты —
     ни один не спрашивает расположение, поэтому оторванный узел им годится.
     ⛔ Это НЕ отменяет правила «строки собираем, а не клонируем»: клон —
     только ИСТОЧНИК ЧИСЕЛ, а строки раздела по-прежнему собираются заново. */
  const pristine = src.cloneNode(true);

  // ⛔ `.hero-around` — раздел «Что вокруг дома», который строит js/jk-card.js на
  //    компе. Его в разметке сервера НЕТ, он появляется только если страницу
  //    ОТКРЫЛИ шире 900 px, а потом повернули телефон в портрет. Без него в этом
  //    списке на экране оказывались ДВА раздела с одним заголовком.
  const HIDE = ['#jkNeighborhood', '#jkNearbyMetros', '#jkInfraList', '#jkInfraQuick', '.hero-around'];

  // Порядок плиток на экране (принят владельцем 20.08). Категории, которых тут
  // нет, идут следом в том порядке, в каком их прислал сервер.
  const ORDER = ['education', 'transport', 'medical', 'shopping', 'leisure'];

  // Деление категории на плитки по значку строки. Ключ — data-cat сервера.
  const SPLIT = {
    education: [
      { icon: 'fa-school',         name: 'Школы',        head: 'fa-school' },
      { icon: 'fa-child-reaching', name: 'Детские сады', head: 'fa-child-reaching' },
      { icon: 'fa-graduation-cap', name: 'Вузы',         head: 'fa-graduation-cap' }
    ]
  };

  // Короткая подпись и значок для НЕделёной плитки. Серверные «Торговля и услуги»
  // и «Образование» в две колонки не влезают, поэтому подписи свои.
  // ⛔ Значок берём ТОЛЬКО из набора сайта: шрифт урезанный (subset.min.css),
  //    fa-suitcase-medical в него не входит и рисуется пустым квадратом.
  //    Проверено по subset.min.css: fa-tree в наборе есть.
  const HEAD = {
    education: { name: 'Образование',     head: 'fa-graduation-cap' },
    transport: { name: 'Транспорт',       head: 'fa-bus' },
    medical:   { name: 'Медицина',        head: 'fa-hospital' },
    shopping:  { name: 'Торговля',        head: 'fa-basket-shopping' },
    leisure:   { name: 'Отдых и природа', head: 'fa-tree' }
  };

  const el = (tag, cls, text) => {
    const n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  };

  // Метры из строки — чтобы показать ближайший объект и не врать «ближайший 1,9 км»,
  // когда в списке есть 400 м.
  const meters = (row) => {
    const t = row.textContent || '';
    const km = t.match(/(\d+[.,]\d+)\s*км/);
    if (km) return parseFloat(km[1].replace(',', '.')) * 1000;
    const m = t.match(/(\d+)\s*м(?!\p{L})/u);
    return m ? parseInt(m[1], 10) : Infinity;
  };

  const human = (m) => (m >= 1000 ? (m / 1000).toFixed(1).replace('.', ',') + ' км' : Math.round(m) + ' м');

  // Склонение по ПОСЛЕДНИМ цифрам, а не по величине числа: 24 — «объекта»,
  // а не «объектов»; 11-14 — всегда «объектов», хотя кончаются на 1-4.
  const noun = (n) => {
    const t = n % 100;
    if (t >= 11 && t <= 14) return 'объектов';
    const d = n % 10;
    if (d === 1) return 'объект';
    if (d >= 2 && d <= 4) return 'объекта';
    return 'объектов';
  };

  const txt = (box, sel) => {
    const n = box.querySelector(sel);
    return n ? n.textContent.trim() : '';
  };

  const hasIcon = (row, icon) => {
    const i = row.querySelector('i[class*="fa-"]');
    return !!i && i.className.split(/\s+/).indexOf(icon) >= 0;
  };

  // ПОЛНОЕ число объектов категории — сервер печатает его в подписи плитки
  // («65 объектов · ближайший 400 м»). Ниже по списку строк оно не считается:
  // список обрезан.
  const fullCount = (box) => {
    const m = txt(box, '.jk-infra-cat__meta').match(/(\d+)\s*объект/);
    return m ? parseInt(m[1], 10) : null;
  };

  // СКОЛЬКО СТРОК СЕРВЕР ВЫВЕЛ. Атрибут заведён ровно для этого (jk_content.php).
  // Если он расходится со строками в DOM — разметку уже кто-то переписал
  // (jk-card.js делит категории на компе), верим тому, что видим.
  const shownCount = (box, domRows) => {
    const raw = box.getAttribute('data-shown');
    if (raw === null || raw === '') return domRows;
    const n = parseInt(raw, 10);
    return isFinite(n) && n === domRows ? n : domRows;
  };

  // Значок сервера — берём только опознаваемый токен `fa-…`, чужие классы не тащим.
  const boxIcon = (box) => {
    const i = box.querySelector('.jk-infra-cat__icon i');
    if (!i) return 'fa-map-pin';
    const hit = (i.className.match(/\bfa-[a-z0-9-]+\b/g) || [])
      .filter((c) => c !== 'fa-chevron-down')[0];
    return hit || 'fa-map-pin';
  };

  /** Разметка одной плитки. total — ПОЛНОЕ число, cut — сколько строк видно (0 = все). */
  const tile = (idx, name, head, rows, total, cut) => {
    const near = Math.min.apply(null, rows.map(meters));
    const card = el('article', 'zd-cat');
    const btn = el('button', 'zd-cat__head');
    btn.type = 'button';
    btn.setAttribute('aria-expanded', 'false');

    const ico = el('span', 'zd-cat__icon');
    const i = el('i', 'fas ' + head);
    i.setAttribute('aria-hidden', 'true');
    ico.appendChild(i);
    btn.appendChild(ico);

    const texts = el('span', 'zd-cat__texts');
    texts.appendChild(el('span', 'zd-cat__label', name));
    // ⛔ Число и расстояние — РАЗНЫМИ узлами: каждый не рвётся внутри себя, а
    //    строка целиком переносится. Одним куском с nowrap счётчик вылезал за
    //    плитку (замер: до 9,7 px при «24»), а с честными «65»/«146» наехал бы
    //    на шеврон.
    const meta = el('span', 'zd-cat__meta');
    meta.appendChild(el('span', 'zd-cat__meta-part', total + ' ' + noun(total)));
    if (isFinite(near)) {
      meta.appendChild(document.createTextNode(' · '));
      meta.appendChild(el('span', 'zd-cat__meta-part', human(near)));
    }
    texts.appendChild(meta);
    btn.appendChild(texts);

    const chev = el('span', 'zd-cat__chev');
    const ci = el('i', 'fas fa-chevron-down');
    ci.setAttribute('aria-hidden', 'true');
    chev.appendChild(ci);
    btn.appendChild(chev);

    const list = el('div', 'zd-cat__list');
    list.id = 'zdcat-' + idx;
    list.hidden = true;

    if (cut > 0) {
      list.appendChild(el('p', 'zd-cat__note',
        'Показаны ' + cut + ' ближайших из ' + total));
    }

    // ⛔ Строку СОБИРАЕМ, а не клонируем. Клон тащит классы `jk-infra-cat__*`,
    //    чьё оформление живёт в стилях старого блока — а старый блок мы гасим
    //    классом .zd-hidden, и клонированные строки становятся невидимыми:
    //    место занимают, текста не видно. Берём только два готовых куска:
    //    название и расстояние, и одеваем их в свои классы.
    rows.forEach((r) => {
      const item = el('div', 'zd-cat__item');
      item.appendChild(el('span', 'zd-cat__name', txt(r, '.jk-infra-cat__name')));
      const dist = txt(r, '.jk-infra-cat__dist');
      if (dist) {
        // ⛔ Пробел ОТДЕЛЬНЫМ узлом: без него выборка текста склеивает соседей —
        //    «Стрелецкая улица400 м». На вид не влияет (пустой узел во flex не
        //    рисуется), а копирование и чтение с экрана чинит.
        item.appendChild(document.createTextNode(' '));
        item.appendChild(el('span', 'zd-cat__dist', dist));
      }
      list.appendChild(item);
    });

    btn.setAttribute('aria-controls', list.id);
    btn.addEventListener('click', () => {
      // ⛔ Раскрытая плитка занимает обе колонки и правая уезжает строкой ниже
      //    (замер: ровно 68 px — высота ряда): человек ткнул пальцем, а список
      //    открылся выше пальца. Держим заголовок на месте: меряем его до и
      //    после перекладки и подводим прокрутку на разницу.
      const before = btn.getBoundingClientRect().top;
      const open = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', open ? 'false' : 'true');
      list.hidden = open;
      card.classList.toggle('zd-cat--open', !open);
      const delta = btn.getBoundingClientRect().top - before;
      if (Math.abs(delta) > 1) window.scrollBy({ top: delta, left: 0, behavior: 'auto' });
    });

    card.appendChild(btn);
    card.appendChild(list);
    return card;
  };

  /** Собирает раздел. Возвращает null, если собирать нечего. */
  const build = () => {
    const host = el('section', 'jk-section zd-around');
    host.appendChild(el('h2', 'jk-section-title zd-around__title', 'Что вокруг дома'));

    /* ⛔ ПЕРЕСБОРКА ПЛАШКИ «N / 100» УДАЛЕНА 26.08.2026 (решение владельца).

       Здесь лента читала .jk-walkability и собирала его число заново
       внутри себя: на телефоне исходная плашка гасилась стилем,
       а то же «60 / 100» появлялось в ленте «Что вокруг дома».

       ⛔ ЭТО РОВНО ТОТ КЛАСС, ИЗ-ЗА КОТОРОГО БЛОК И УБИРАЛСЯ: одно число
       живёт в двух местах, и убрать только одно — значит не убрать ничего.
       Исходной секции больше нет в отдаваемом HTML, собирать нечего.
       Объяснение с замером — в app/templates/pages/jk_content.php,
       ищи «ПЕШАЯ ДОСТУПНОСТЬ N / 100 УБРАНА». */

    host.appendChild(el('p', 'zd-around__hint', 'Нажмите на категорию, чтобы раскрыть список'));

    // 2. Плитки-аккордеоны в два столбца.
    const grid = el('div', 'zd-around__grid');
    let idx = 0;
    // ⛔ Хоть одна строка не попала в плитки — исходный блок НЕ гасим. Иначе
    //    объект исчезает со страницы совсем: диверсия проверяющего стёрла значки
    //    у трёх школьных строк, и 62 объекта «Образования» пропали бесследно.
    let complete = true;

    // ⛔ ЧИТАЕМ СНИМОК, А НЕ ЖИВОЙ УЗЕЛ — см. про перекройку в начале файла.
    //    Живой `src` ниже по-прежнему нужен: его гасим и от него отсчитываем
    //    место вставки, а это про сам документ, а не про числа.
    const boxes = [...pristine.querySelectorAll('.jk-infra-cat')];
    const rank = (b) => {
      const p = ORDER.indexOf(b.getAttribute('data-cat') || '');
      return p < 0 ? ORDER.length : p;
    };
    boxes
      .map((b, i) => ({ b, i }))
      .sort((x, y) => (rank(x.b) - rank(y.b)) || (x.i - y.i))
      .forEach(({ b }) => {
        const key = b.getAttribute('data-cat') || '';
        const all = [...b.querySelectorAll('.jk-infra-cat__item')];
        if (!all.length) return;

        // Строка без названия дала бы пустую строчку в списке при непустом
        // счётчике. Такую не показываем — и признаём разбор неполным.
        const rows = all.filter((r) => txt(r, '.jk-infra-cat__name') !== '');
        if (rows.length !== all.length) complete = false;
        if (!rows.length) { complete = false; return; }

        const shown = shownCount(b, all.length);
        const full = fullCount(b);
        const total = full === null ? rows.length : full;
        const cut = total > shown ? rows.length : 0;

        // Делим только по полному и полностью узнанному списку — см. шапку файла.
        let packs = null;
        if (SPLIT[key] && !cut) {
          const p = SPLIT[key].map((g) => ({ g, rows: rows.filter((r) => hasIcon(r, g.icon)) }));
          const known = p.reduce((s, x) => s + x.rows.length, 0);
          const live = p.filter((x) => x.rows.length > 0);
          if (known === rows.length && live.length) packs = live;
        }

        if (packs) {
          packs.forEach((p) => grid.appendChild(tile(idx++, p.g.name, p.g.head, p.rows, p.rows.length, 0)));
        } else {
          const h = HEAD[key] || { name: txt(b, '.jk-infra-cat__label'), head: boxIcon(b) };
          grid.appendChild(tile(idx++, h.name || 'Рядом', h.head, rows, total, cut));
        }
      });

    if (!idx) return null;
    host.appendChild(grid);

    // 3. Ссылка на карту — как на компе.
    const map = document.getElementById('jkMap');
    if (map) {
      const link = el('a', 'zd-around__map', 'Посмотреть на карте');
      link.href = '#jkMap';
      link.addEventListener('click', (e) => {
        e.preventDefault();
        map.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
      host.appendChild(link);
    }

    // 4. Место раздела — СРАЗУ ПОСЛЕ блока квартир (решение владельца 20.08:
    //    «что вокруг дома поставь после этого блока … Все 1416 квартир»).
    //    Смысл порядка: человек сначала смотрит, что продаётся, и только потом —
    //    что вокруг. Если блока квартир нет (у части ЖК он пуст), встаём на место
    //    первого убираемого блока, как раньше.
    //
    // ⛔ НА СТРАНИЦЕ КОМНАТНОСТИ РАЗДЕЛ НЕ ПЕРЕЕЗЖАЕТ (ADR-125, 28.08.2026). Там
    //    порядок задан владельцем и он ДРУГОЙ: рендеры → фильтр → планировки → лоты →
    //    ипотека → что вокруг и карта → похожие → подвал. Перенос «сразу за #jkFlats»
    //    выбросил бы раздел на телефоне выше планировок, лотов и ипотеки, то есть
    //    сломал бы ровно то, ради чего страница собрана. Признак страницы группы —
    //    `window.BRONI_JK_ROOMS_PINNED`, тот же единственный, что читает jk.js.
    const isRoomsPage = typeof window !== 'undefined' && !!window.BRONI_JK_ROOMS_PINNED;
    const flats = document.getElementById('jkFlats');
    if (isRoomsPage) {
      // Раздел остаётся на своём месте в потоке: собран из узлов `#jkInfraCategories`,
      // туда же и встаёт — сразу перед источником.
      src.parentNode.insertBefore(host, src);
    } else if (flats && flats.parentNode) {
      flats.parentNode.insertBefore(host, flats.nextSibling);
    } else {
      const anchor = document.getElementById('jkNeighborhood') || src;
      anchor.parentNode.insertBefore(host, anchor);
    }

    const hidden = [];
    HIDE.forEach((sel) => {
      document.querySelectorAll(sel).forEach((n) => { if (n !== host) hidden.push(n); });
    });
    if (complete) hidden.push(src);
    return { host: host, hidden: hidden };
  };

  // ⛔ ШИРИНУ СЛУШАЕМ, А НЕ ЗАМЕРЯЕМ ОДИН РАЗ. Телефон в альбоме шире 900 px
  //    (iPhone Pro Max 932, Galaxy S23 Ultra ~915). Раньше при повороте правило
  //    `.zd-hidden` переставало действовать — прод-блоки возвращались, а наш
  //    раздел оставался в потоке без сетки: 77 названий на экране ДВАЖДЫ.
  //    Теперь при уходе выше 900 снимаем `.zd-hidden` (прод-блоки на месте), а
  //    раздел прячет стилями `@media (min-width: 901px)` — то есть даже если этот
  //    обработчик не отработает, простыни не будет.
  let state = null;
  const apply = (narrow) => {
    if (narrow && !state) state = build();
    if (!state) return;
    state.hidden.forEach((n) => n.classList.toggle('zd-hidden', narrow));
  };

  apply(MQ.matches);
  if (MQ.addEventListener) MQ.addEventListener('change', (e) => apply(e.matches));
  else if (MQ.addListener) MQ.addListener((e) => apply(e.matches));
})();
